import { FC } from 'react'
import { useField } from 'react-final-form'

import SelectMenu, { Props as SelectMenuProps } from '../molecules/SelectMenu'

type Props = Pick<SelectMenuProps, 'isConfirm' | 'required'>

const NAME = 'howToFind'

const HowToFindField: FC<Props> = ({ isConfirm, required }) => {
  const {
    input: { value },
  } = useField(NAME)

  if (isConfirm && !value) return null

  return (
    <div data-cy='howToFind'>
      <SelectMenu
        name={NAME}
        label='サクサク仕事探しを知ったキッカケ'
        isConfirm={isConfirm}
        required={required}
        options={[
          '仕事相手、同僚、知人、友人から',
          '検索エンジン（Google、Yahoo!など）',
          'Google、Yahoo!広告',
          'Twitter',
          'Facebook',
          'Instagram',
          'SNS広告',
          'TIME MACHINEコーポレートサイト',
          'プレリリース（PR TIMES、＠Pressなど）',
          'その他',
        ]}
      />
    </div>
  )
}

HowToFindField.displayName = 'howToFind'

export default HowToFindField
